module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [_c('ModalReveal', {
    ref: _vm.componentId
  }, [_c('a', {
    staticClass: "fa-stack fa-lg",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x"
  }), _c('i', {
    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
  })]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Action"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.action),
      expression: "body.action"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Route name or route path on the app"
    },
    domProps: {
      "value": (_vm.body.action)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "action", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Title"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.title),
      expression: "body.title"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.body.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "title", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Slug"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.slug),
      expression: "body.slug"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.body.slug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "slug", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Button label"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.button_labels),
      expression: "body.button_labels"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.body.button_labels)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "button_labels", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "row column"
  }, [_c('label', [_vm._v("Content")]), _c('Editor', {
    model: {
      value: (_vm.body.content),
      callback: function($$v) {
        _vm.$set(_vm.body, "content", $$v)
      },
      expression: "body.content"
    }
  })], 1), _c('ActionButton', {
    attrs: {
      "slot": "footer",
      "action": _vm.save
    },
    slot: "footer"
  }, [_vm._v("Save")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2b985b65!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/CreatePageReveal.vue
// module id = 2362
// module chunks = 1